import React from 'react';

import { INoteworthySocialProofFields } from '../../../types/contentful';

import { Asset } from '../AtomicComponents/Asset';
import cx from 'classnames';

export function NoteworthySocialProof({
  header,
  backgroundColor,
  badges
}: INoteworthySocialProofFields) {
  const defaultBgColor = '#F8F7F3';
  const bgColor = backgroundColor || defaultBgColor;
  const bgStyle = bgColor.startsWith('#')
    ? { backgroundColor: bgColor }
    : undefined;

  const hasDescription =
    badges &&
    badges.some(
      (badge) =>
        badge?.fields?.descriptionHeader || badge?.fields?.descriptionSubcopy
    );

  return (
    <div
      id="noteworthySocialProof"
      className="w-full px-4 py-10 tablet:px-6 tablet:py-10 -mt-20 tablet:-mt-[120px]"
      style={bgStyle}
      data-blockid="noteworthySocialProof"
      data-testid="noteworthySocialProofContainer"
    >
      <h2
        className="mb-8 text-center text-[36px] font-normal leading-[43.2px] tracking-[0] text-[#111212] tablet:mb-10"
        data-testid="socialProofHeader"
      >
        {header}
      </h2>

      {badges && badges.length > 0 && (
        <div
          className={cx(
            'items-center desktop:flex-row desktop:flex-nowrap desktop:justify-center',
            {
              'tiny:grid tiny:grid-cols-2 tiny:justify-items-center desktop:!flex':
                !hasDescription,
              'flex flex-col justify-center gap-6 tablet:items-center tablet:justify-center tablet:gap-6 desktop:flex-row desktop:flex-wrap':
                hasDescription
            }
          )}
        >
          {badges.map((badge, index) => {
            const badgeFields = badge?.fields;
            const badgeImage = badgeFields?.badgeImage;
            const descriptionHeader = badgeFields?.descriptionHeader;
            const descriptionSubcopy = badgeFields?.descriptionSubcopy;

            return (
              <div
                key={badge?.sys?.id || index}
                className={cx("flex flex-shrink-0 flex-row tiny:items-center tiny:justify-center tiny:gap-0 mobile:gap-6",{
                  'mb-6 desktop:gap-10': !hasDescription,
                  'desktop:gap-4 mb-6': hasDescription

                })}
              >
                {badgeImage && (
                  <div
                    className={cx('flex h-[140px] w-[140px] flex-shrink-0 items-center justify-center [&_div]:h-[140px] [&_div]:w-[140px] [&_div]:object-contain [&_img]:h-[140px] [&_img]:w-[140px] [&_img]:object-contain',{
                      'desktop:mr-16': !hasDescription
                    })}
                  >
                    <Asset
                      asset={badgeImage}
                      alt={badgeFields?.contentfulLabel}
                    />
                  </div>
                )}
                {hasDescription && (
                  <div className="tiny:ml-6 desktop:ml-4 mt-7 flex w-[165px] flex-col">
                    {descriptionHeader && (
                      <h3
                        className="typography-title-4 mb-1 text-[16px] font-medium leading-[19.2px] tracking-[0] text-[#111212] tablet:mb-3"
                        data-testid={`descriptionHeader-${index}`}
                      >
                        {descriptionHeader}
                      </h3>
                    )}
                    {descriptionSubcopy && (
                      <p
                        className="text-[16px] font-normal leading-[19.2px] tracking-[0] text-[#111212]"
                        data-testid={`descriptionSubcopy-${index}`}
                      >
                        {descriptionSubcopy}
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
